import {StrictMode} from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from "@react-oauth/google";

const rootElement = document.getElementById("root");
const root = ReactDOMClient.createRoot(rootElement);

root.render(
  <StrictMode>
    <GoogleOAuthProvider clientId="909687983816-2gnn1lnr4oviisi12e88hepbo1b4lsgo.apps.googleusercontent.com">
      <App />
    </GoogleOAuthProvider>
  </StrictMode>
);

// Single, TWA-aware service worker registration. Skipped inside a
// Trusted Web Activity (the Android/Play Store wrapper) because the
// TWA shell manages its own service worker lifecycle — registering
// ours on top of it there can cause update/caching conflicts.
const isTWA =
  navigator.userAgent.toLowerCase().includes('wv') ||
  document.referrer.includes('android-app://');

if (!isTWA) {
  serviceWorkerRegistration.register();
}

reportWebVitals();
